import { useCallback } from "react";
import { flushSync } from "react-dom";

type StartViewTransition = (updateStateCallback: () => void) => void;

type DocumentWithStartViewTransition = Document & {
  startViewTransition?: (callback: () => void) => void;
};

export const useViewTransitionStateUpdate = (
  iframeDocument: Document | undefined
): StartViewTransition => {
  return useCallback(
    (updateStateCallback: () => void) => {
      const doc = iframeDocument as DocumentWithStartViewTransition | undefined;
      if (doc == null || !doc.startViewTransition) {
        // Execute updateStateCallback immediately if we cannot use document.startViewTransition
        updateStateCallback();
        return;
      }
      doc.startViewTransition(() => {
        // Use flushSync so React applies any state changes immediately inside of the
        // startViewTransition context
        flushSync(() => {
          updateStateCallback();
        });
      });
    },
    [iframeDocument]
  );
};
